import getSeconds from './get-seconds';

export { getSeconds };

export default getSeconds;
